module.exports = __webpack_public_path__ + "static/media/tab_team.ac507e6f.png";